"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var baseViewModel_1 = require("./base/baseViewModel");
var Clipboard = require("clipboard");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.isLoading = ko.observable(false);
        this.sorting = ko.observable();
        this.rp = ko.observable();
        this.exceptMyLibrary = ko.observable(false);
        this.resetFilters = function () {
            _this.sorting("default");
            _this.rp("today");
            _this.exceptMyLibrary(false);
            _this.submit();
        };
        this.submit = function (formElement, extendedData) {
            var exceptMyLibrary = _this.exceptMyLibrary(), sorting = _this.sorting(), rp = _this.rp();
            var params = {};
            if (sorting !== "default") {
                params.sorting = sorting;
            }
            if (sorting === "popular" && rp !== "today") {
                params.rp = rp;
            }
            if (exceptMyLibrary) {
                params.eml = exceptMyLibrary;
            }
            var url = app.rootUrl + ("litmob/" + _this.litmobId + "?" + $.param(params));
            window.location.replace(url);
        };
        if (options) {
            this.litmobId = options.litmobId;
            this.sorting(options.sorting);
            this.rp(options.rp);
            this.exceptMyLibrary(options.eml);
        }
        var urlClipboard = new Clipboard("#litmobUrl");
        urlClipboard.on("success", function () {
            alert("Ссылка на литмоб скопирована.");
            app.closeModal();
        });
        urlClipboard.on("error", function (e) {
            var $el = $(e.trigger);
            var url = $el.attr("data-clipboard-target");
            prompt("Ссылка на литмоб", url);
            app.closeModal();
        });
        if ($("#findWorkCollectionPopup").length) {
            ko.applyBindings(this, $("#findWorkCollectionPopup")[0]);
            $(".chip-search-books").on("click", function () {
                _this.app.closePopup();
                _this.app.f7.popup("#findWorkCollectionPopup");
            });
        }
    }
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=litmobView.js.map